module.exports = __webpack_public_path__ + "static/media/niivana-home.b18c4051.png";